import { render, staticRenderFns } from "./candidatePlacing.vue?vue&type=template&id=5e72e9dc&scoped=true&"
import script from "./candidatePlacing.vue?vue&type=script&lang=js&"
export * from "./candidatePlacing.vue?vue&type=script&lang=js&"
import style0 from "./candidatePlacing.vue?vue&type=style&index=0&id=5e72e9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72e9dc",
  null
  
)

export default component.exports